module.exports = __webpack_public_path__ + "static/img/p6.a881e3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/parkServices/p6.jpg
// module id = BdxW
// module chunks = 1